module.exports = __webpack_public_path__ + "img/police.54cf637c.jpeg";